export default __webpack_public_path__ + "static/media/logo.d5b355d4.svg";